import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './body.css'; // Assuming you're using CSS modules

import { FaUniversity, FaRegNewspaper, FaGraduationCap, FaUser, FaGlobe, FaUsers, FaChalkboardTeacher, FaMoneyCheckAlt, FaHandshake } from "react-icons/fa";


// import { Carousel } from 'react-bootstrap';
// import { Card, CardContent } from "../../Components/ui/card";
// import { Globe, Users, Handshake, Radius } from "lucide-react";

import { motion } from "framer-motion";
import "./body.css"; 

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


import { Download } from "lucide-react";






const cards = [
  {
    title: "Registration",
    description:
      "Register before 24th of January to secure your spot at the conference and enjoy discounted rate. Don't miss out!",
    button: "Register Now",
    icon: "📝",
    link: "/payment",
  },


  {
    title: "Abstract Submission",
    description:
      "Submit your research or case studies to be considered for presentation at the conference. Ensure you follow the submission guidelines.",
    button: "Submit Now",
    icon: "🗂️",
    link: "/abstract",
  },


  {
    title: "Abstract Status",
    description:
      "Check the review status of your submitted abstract. Stay updated on acceptance and presentation schedules.",
    button: "View Status",
    icon: "📋",
    link: "/abstract",  
  },


  {
    title: "Book a Stall",
    description:
      "Showcase your products or services by booking a stall at the event. Limited slots available on a first-come, first-served basis.",
    button: "Book Now",
    icon: "🏬",
    link: "/stall",
  },





];




function Body() {








  // const [timeLeft, setTimeLeft] = useState(
  //   Math.floor((new Date("2026-01-25T08:30:00") - new Date()) / 1000)
  // );


  // Carousel settings
  const settings = {
    infinite: true, // Infinite scroll
    speed: 1000, // Transition speed
    slidesToShow: 3, // Show 3 brands at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable auto play
    autoplaySpeed: 2000, // Change image every 2 seconds
    pauseOnHover: true, // Pause when hover
    responsive: [
      {
        breakpoint: 1024, // For larger devices
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600, // For mobile
        settings: {
          slidesToShow: 1, // Show 1 brand on mobile
        },
      },
    ],
  };















  

  // useEffect(() => {
  //   if (timeLeft <= 0) return;
  //   const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
  //   return () => clearInterval(timer);
  // }, [timeLeft]);

  // const formatTime = (seconds) => {
  //   const months = Math.floor(seconds / (30 * 24 * 60 * 60));
  //   const days = Math.floor((seconds % (30 * 24 * 60 * 60)) / (24 * 60 * 60));
  //   const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
  //   const minutes = Math.floor((seconds % (60 * 60)) / 60);
  //   const secs = seconds % 60;
  //   return { months, days, hours, minutes, secs };
  // };

  // const time = formatTime(timeLeft);

const targetDate = new Date("2027-01-23T08:30:00").getTime();

const [timeLeft, setTimeLeft] = useState(() =>
  Math.max(0, Math.floor((targetDate - Date.now()) / 1000))
);

useEffect(() => {
  if (timeLeft <= 0) return;

  const timer = setInterval(() => {
    setTimeLeft((prev) => Math.max(0, prev - 1));
  }, 1000);

  return () => clearInterval(timer);
}, [timeLeft]);

const formatTime = (seconds) => {
  const months = Math.floor(seconds / (30 * 24 * 60 * 60));
  const days = Math.floor((seconds % (30 * 24 * 60 * 60)) / (24 * 60 * 60));
  const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((seconds % (60 * 60)) / 60);
  const secs = seconds % 60;

  return { months, days, hours, minutes, secs };
};

const time = formatTime(timeLeft);










  // Track expanded sessions
  const [expanded, setExpanded] = useState({});

  // Toggle function
  const toggleSession = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };





  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedImage, setExpandedImage] = useState(null);
  const intervalRef = useRef(null);

  const images = [
    { src: "/hotel4.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel3.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel1.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel2.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel5.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel6.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel7.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel8.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel9.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel10.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel11.jpg", alt: "Monarch Imperial Hotel" },
    { src: "/hotel12.jpg", alt: "Monarch Imperial Hotel" }
  ];

  // Always show 3 images (current, next, and previous)
  const visibleImages = [];
  for (let i = -1; i <= 1; i++) {
    const index = (currentIndex + i + images.length) % images.length;
    visibleImages.push(images[index]);
  }

  const moveNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const movePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleImageClick = (image) => {
    setExpandedImage(image);
    clearInterval(intervalRef.current);
  };

  const closeExpandedImage = () => {
    setExpandedImage(null);
    intervalRef.current = setInterval(moveNext, 2000);
  };

  useEffect(() => {
    intervalRef.current = setInterval(moveNext, 2000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleMouseEnter = () => clearInterval(intervalRef.current);
  const handleMouseLeave = () => {
    if (!expandedImage) {
      intervalRef.current = setInterval(moveNext, 2000);
    }
  };










  return (
    <>
    <div className="banner-container">
        <div className="banner-image">
      <img src="/eye care 2027 banner.png" alt="Banner" />
      </div>
      <div className="countdown">
        <span>
          <strong>{time.months}</strong>
          <small>Months</small>
        </span>
        
        <span>
          <strong>{time.days}</strong>
          <small>Days</small>
        </span>
        <span>
          <strong>{time.hours}</strong>
          <small>Hours</small>
        </span>
        <span>
          <strong>{time.minutes}</strong>
          <small>Minutes</small>
        </span>
        <span>
          <strong>{time.secs < 10 ? "0" : ""}{time.secs}</strong>
          <small>Seconds</small>
        </span>
      </div>
    </div>












<div className="who-we-are-container">
  <h2 className="section-title">Message From Event Chairperson</h2>
  
  <div className="message-content">
    <div className="message-text">
      <p className="about-text">
        <span className="highlight-text">Diyatharippu - Eye Care 2026</span> It is with immense pleasure and pride that I welcome you to 
        Diyataripu-the 1st International Optometry conference in Sri Lanka, held in conjunction with the Eye Care 2026 Annual scientific Conference 
        of Eye Care Institute and Ceylon Eye Care Optometric Association, from January 25th  & 26th , 2026, in the vibrant and historic city 
        of Colombo, Sri Lanka. </p>
      
      <p className="about-text">
       This conference brings together the brightest minds from across the world, and we are excited to host them. This event promises to be 
       an extraordinary opportunity for knowledge exchange, collaboration, and advancing the future of eye care.
      </p>

      <p className='about-text'>As we embark on this exciting journey of learning, collaboration, and innovation, I encourage each of you to seize 
        every opportunity to engage with colleagues, exchange ideas, and build new partnerships that will shape the future of Eye Care. Together, 
        we can continue to make significant strides in improving patient outcomes and advancing the science of Optometry.</p>

      <p className="about-text"><span className="highlight-text">I wish you all an enriching, inspiring, and enjoyable conference experience. 
        May this gathering serve as a catalyst for future innovations, collaborations, and advancements in the years ahead.</span></p>

      
      <div className="signature-block">
        <p className="signature-name">Optom. Narresh Pradhan</p>
        <p>Event Chairperson, Eye Care 2026</p>
        <p>Program Director, Eye Care Institute</p>
      </div>
    </div>
    
    <div className="event-chairperson-image-container">
      <img 
        src='/optomnaresh.png' 
        alt='Event Chairperson' 
        className='event-chairperson-image' 
        loading="lazy"
      />
    </div>
  </div>
</div>














{/* <div class="banner-container">
  <div class="banner-image">
    <img src="/banner-g.png" alt="Conference Banner" class="responsive-banner"/>
    <div class="curve-overlay"></div>
    <div class="banner-content">
      <div class="conference-title">1st International Optometric Conference</div>
      <div class="location">DIYATHARIPPU</div>
      <div class="event-name-eye">EYE CARE 2026</div>
      <div class="date">24th 25th 26th, January</div>
      <div class="venue">Monarch Imperial Hotel - Colombo, Sri Lanka</div>
    </div>
  </div>
</div> */}






    





























      {/* Conference Details & Video Section */}
      <motion.div
        className="conference-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        
{/* Left Side - Conference Details */}
<div className="conference-details">
  <h1 className="title">1st International Optometry Conference</h1>
  <h3 className="subtitle"><b>Shaping the Future of Eye Care Through Global Collaboration</b></h3>

  <motion.p
    className="conference-description"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay: 0.3 }}
  >
It is with immense pleasure and profound excitement that I extend a heartfelt welcome to you all as the Event 
Chairperson of our very first International Optometry Conference! Hosted here in this landmark event marks a pivotal moment for the optometric community, bringing together leading experts, dedicated practitioners, passionate researchers, 
and enthusiastic students from across the globe.

  </motion.p>

  <motion.ul
    className="conference-highlights"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay: 0.5 }}
  >
    <li><strong>Knowledge Exchange</strong> – Insightful keynote presentations and groundbreaking research presentations.</li>
    <li><strong>Collaborative Relationships</strong> – Fostering connections that will shape the future of optometry.</li>
    <li><strong>Innovative Technologies</strong> – Exploration of cutting-edge advancements in vision care.</li>
  </motion.ul>

  <motion.p
    className="conference-footer"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay: 0.7 }}
  >
    Join us in this historic inaugural event as we lay the foundation for a tradition 
    of excellence in our mission to enhance vision and improve lives worldwide.
  </motion.p>
</div>

            {/* Right Side - YouTube Video */}
            <motion.div
              className="video-container"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/vwpOlzmfvrk?si=40fCzNCB8ON3hQmz"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </motion.div>
          </motion.div>












          <section className="speakers-section">
            <div className="container-speaker">
              <h1 className="heading-speaker">International Speakers</h1>
              <div className="speakers-list">

              
                <div className="speaker-card">
                  <Link to="/prof-kovin-naidoo" className="speaker-link">
                    <img src="/internationalSpeakers/kovin.png" alt="Prof. kovin shunmugam naidoo" />
                    <h3>Prof. Kovin S. Naidoo</h3>
                    <p>BSc, BOptom, MPH, OD, PhDAfrican Vision Research Institute at University of KwaZulu-Natal</p>
                    <p className="speaker-link">More Info</p>
                  </Link>
                </div>



                <div className="speaker-card">
                  <Link to="/dr-rajeev-prasad" className="speaker-link">
                  <img src="/internationalSpeakers/dr.rajeev.jpg" alt="Dr. Rajeev Prasad" />
                  <h3>Dr. Rajeev Prasad</h3>
                  <p>Snr. clinical Optometrist, BHMS, Director Board Of Directors at World Council Of Optometry</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/yeshwanth-saoji" className="speaker-link">
                  <img src="/internationalSpeakers/yeshwanth.jpeg" alt="Yeshwant Saoji<" />
                  <h3>Yeshwant Saoji</h3>
                  <p>Chief Optometrist - Saoji Vision Care</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/lakshmi-shinde" className="speaker-link">
                  <img src="/internationalSpeakers/lakshmishin.jpg" alt="Lakshmi Shinde" />
                  <h3>Lakshmi Shinde</h3>
                  <p>OCI, DIRECTOR GLOBAL Education, IACLE</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/junu-shrestha" className="speaker-link">
                  <img src="/internationalSpeakers/junu.jpg" alt="Junu shrestha" />
                  <h3>Junu shrestha</h3>
                  <p>MSc Health Policy Planning and Financing, Policy and Advocacy Manager at IAPB</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/prof-azrin-esmady-ariffin" className="speaker-link">
                  <img src="/internationalSpeakers/Azrin.jpg" alt="Prof. Azrin Esmady Ariffin" />
                  <h3>Prof. Azrin Esmady Ariffin</h3>
                  <p>BOptom, PhD, Head of Faculty at SEGi University</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>
              
                <div className="speaker-card">
                  <Link to="/dr-cathy-stern" className="speaker-link">
                  <img src="/internationalSpeakers/cathy.jpg" alt="Dr. Cathy Stern" /> 
                  <h3>Dr. Cathy Stern</h3>
                  <p>OD, FCSO, FCOVD, FNORA</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                  <Link to="/dr-prakash-paudel" className="speaker-link">
                  <img src="/internationalSpeakers/Dr.Prakash.jpg" alt="Dr. Prakash Paudel" />
                  <h3>Dr. Prakash Paudel</h3>
                  <p>PhD, BOptom, BSc, FIACLEAdjunct Senior Lecturer UNSW. Health Education Officer, NSW Health, Australia</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/dr-aditya-goyal" className="speaker-link">
                  <img src="/Dr.Aditya-Goyal.jpg" alt="Dr. Aditya Goyal" />
                  <h3>Prof. Aditya Goyal</h3>
                  <p>M.S. in Clinical Optometry, and a Ph.D, Fellow of the College of Optometrists in Vision Development (COVD) </p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                  <div className="speaker-card">
                  <Link to="/Prof-Zaki-Awg-Isa" className="speaker-link">
                  <img src="/Prof. M Zaki Awg Isa.jpg" alt="Prof. M Zaki Awg Isa" />
                  <h3>Prof. M Zaki Awg Isa</h3>
                  <p>PhD, MCOptom(UK), </p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                  <Link to="/Dr-raju-kaiti" className="speaker-link">
                  <img src="/internationalSpeakers/dr raju.jpg" alt="Dr. Raju Kaiti" />
                  <h3>Dr. Raju Kaiti</h3>
                  <p>B. Optom, MSc. Optometry, PhD, Eye Health Hero- Future Leader (IAPB), 2021, Associate Professor AT NAMS</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                  <Link to="/dr-vasumathy" className="speaker-link">
                  <img src="/internationalSpeakers/dr vasumathy.jpg" alt="dr vasumathy " />
                  <h3>Dr. Vasumathy Vedantham</h3>
                  <p>MS, DNB, FRCS (Edinburgh), FIAMS, Ophthalmologist, Vitreoretinal Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/mohammad-mizanur-rahman" className="speaker-link">
                  <img src="/internationalSpeakers/MohammadMizanurRahman.png" alt="Mohammad Mizanur Rahman" />
                  <h3>Dr. Mohammad Mizanur Rahman</h3>
                  <p>PhD. Assistant Professor and Research Fellow at Management and Science University</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                
                <div className="speaker-card">
                  <Link to="/sanjeeb-kumar-mishra" className="speaker-link">
                  <img src="/internationalSpeakers/sanjeeb mishra.png" alt="Sanjeeb Kumar Mishra" />
                  <h3>Sanjeeb Kumar Mishra</h3>
                  <p>B. Optom, MSc, The Past President of Nepalese Association of Optometrists  (from 2014-2018)</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>
                





                <div className="speaker-card">
                  <Link to="/dipak-kumar-sah" className="speaker-link">
                  <img src="/internationalSpeakers/deepak.png" alt="Dipak Kumar Sah" />
                  <h3>Dipak Kumar Sah</h3>
                  <p>Chevening Scholar Public Health professional,Health Policy, Planning and Financing expert Eye care Advocate and Physician ( Vision Specialist)</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>



                <div className="speaker-card">
                  <Link to="/Mohammd-Noim-Uddin" className="speaker-link">
                  <img src="/Mohammd-Noim-Uddin.jpg" alt="Mohammd-Noim-Uddin" />
                  <h3>Mohammad Noim Uddin</h3>
                  <p>B.Optom, MPH, Senior Optometrist, Lions Eye Institute & Hospital Chittagong, Bangladesh </p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/fakhruddin-barodawala" className="speaker-link">
                  <img src="/internationalSpeakers/Fakhruddin.jpg" alt="Fakhruddin Barodawala" />
                  <h3>Fakhruddin Barodawala</h3>
                  <p>M. Optom, FASCO (Dispensing Optics), FIACLE, FAAO, FBCLA.Lecturer at SEGi University</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                   <div className="speaker-card">
                  <Link to="/dr-indira-madhavan" className="speaker-link">
                  <img src="/Dr.Indira-Madhavan.png" alt="Dr. Indira Madhavan" />
                  <h3> Indira Madhavan</h3>
                  <p>BOptom MHSc (Optometry), PhD, Senior Lecturer at SEGi University, Malaysia</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                  <Link to="/irene-sophia-joseph" className="speaker-link">
                  <img src="/internationalSpeakers/Irene Photo .jpeg" alt="  Irene Sophia Joseph" />
                  <h3> Irene Sophia Joseph</h3>
                  <p>FAAO, FBCLA, FIAOMC| Specialist Optometrist | Genesis Healthcare Center, Dubai  </p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


              
              </div>
            </div>
          </section>






          <section className="speakers-section">
            <div className="container-speaker">
              <h1 className="heading-speaker">National Speakers</h1>
              <div className="speakers-list">


                <div className="speaker-card">
                   <Link to="/dr-kusum-rathnayake" className="speaker-link">
                  <img src="/localSpeakers/Dr-Kusum.jpg" alt="Dr. Kusum Ratnayake" />
                  <h3>Dr. Kusum Ratnayake</h3>
                  <p>Consultant, Cornea & Refractive Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                  <Link to="/dr-amila-de-alwis" className="speaker-link">
                  <img src="/localSpeakers/dramila.jpg" alt="Dr. amila De Alwis" />
                  <h3>Dr. amila De Alwis</h3>
                  <p>Consultant Eye Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                   <Link to="/dr-ayashmantha-peiris" className="speaker-link">
                  <img src="/localSpeakers/drayasmantha.jpg" alt="Dr. Ayasmantha Peiris " />
                  <h3>Dr. Ayasmantha Peiris </h3>
                  <p>Consultant Eye Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                   <Link to="/dr-m-kumaradas" className="speaker-link">
                  <img src="/localSpeakers/drkumaradas.jpg" alt="Dr. M kumaradas <" />
                  <h3>Dr. M kumaradas </h3>
                  <p>Consultant Eye Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link> 
                </div>

                <div className="speaker-card">
                    <Link to="/dr-muthusamy-malaravan" className="speaker-link">
                  <img src="/localSpeakers/drMuthusamy.jpg" alt="Dr. Muthusamy Malaravan" />
                  <h3>Dr. Muthusamy Malaravan</h3>
                  <p>Consultant Eye Surgeon</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>


                <div className="speaker-card">
                   <Link to="/upali-seekubadu" className="speaker-link">
                  <img src="/localSpeakers/sekkubadu.jpg" alt="Upali Seekubadu " />
                  <h3>Upali Seekubadu </h3>
                  <p>Snr.  Orthoptist<br/>founder Binocular vision Unit<br/>NEH Colombo</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                    <Link to="/amila-chandrasekara" className="speaker-link">
                  <img src="/localSpeakers/amila.png" alt="Amila chandrasekara" />
                  <h3>Amila chandrasekara </h3>
                  <p>Principal, Vision Care Academy</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                {/* <div className="speaker-card">
                   <Link to="/naveen-samarasinghe" className="speaker-link">
                  <img src="/localSpeakers/naveens.jpg" alt="Naveen Samarasinghe" />
                  <h3>Naveen Samarasinghe</h3>
                  <p>Optometrist<br/>EYESAVERS - Kandy</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div> */}

                <div className="speaker-card">
                   <Link to="/naresh-pradhan" className="speaker-link">
                  <img src="/localSpeakers/optomnaresh.jpg" alt="Narresh Pradhan" />
                  <h3>Narresh Pradhan</h3>
                  <p>Programme Director<br/>Eye Care Institute</p>
                  <p className="speaker-link">More Info</p>
                  </Link> 
                </div>

                <div className="speaker-card">
                   <Link to="/dr-chathurie-nupearachchi" className="speaker-link">
                  <img src="/localSpeakers/chathurie.jpeg" alt="Dr. Chathurie Nupearachchi" />
                  <h3>Dr. Chathurie Nupearachchi </h3>
                  <p>Senior Lecturer, Physics, PhD Physics, University of Sri Jayewardenepura</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                   <Link to="/pooja-ranasinghe" className="speaker-link">
                  <img src="/localSpeakers/pooja.png" alt="Pooja Ranasinghe" />
                  <h3>Pooja Ranasinghe</h3>
                  <p>Lecturer, University of Sri Jayawardhanapura</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

                <div className="speaker-card">
                    <Link to="/lilendra-perera" className="speaker-link">
                  <img src="/localSpeakers/lilendra.jpg" alt="lilendra Perera" />
                  <h3>lilendra Perera</h3>
                  <p>Optometrist<br/>Panora Eye Hostipal- Gampaha</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>
                
                <div className="speaker-card">
                    <Link to="/thusil-thilan-gunawardena" className="speaker-link">
                  <img src="/localSpeakers/thusilthilan.jpg" alt="Thusil Thilan Gunawardena" />
                  <h3>Thusil Thilan Gunawardena </h3>
                  <p>Orthoptist, National Eye Hospital Colombo</p>
                  <p className="speaker-link">More Info</p>
                  </Link>
                </div>

              </div>
            </div>
          </section>


     <div className="conf-home-container">
      <div className="conf-cards-grid">
        {cards.map((card, index) => (
          <div key={index} className="conf-card">
            <div className="conf-card-icon">{card.icon}</div>
            <h3 className="conf-card-title">{card.title}</h3>
            <p className="conf-card-description">{card.description}</p>
            <a href={card.link} className="conf-card-button">
              {card.button}
            </a>
          </div>
        ))}
      </div>
    </div>





<div className="who-can-join-container">
  <h1>Who Can Join?</h1>
  <ul>
    <li>Optometrist</li> 
    <li>Optician</li> 
    <li>Orthoptics</li> 
    <li>Ophthalmologist</li> 
    <li>General Physician</li> 
    <li>Family Medicine Consultant</li> 
    <li>Ophthalmology Residence</li> 
    <li>Nurse</li> 
    <li>Allied Health Professionals</li> 
    <li>Optometry Students</li> 
    <li>Industry Delegates</li> 
    <li>Researchers & Policy Makers</li> 
  </ul>                                                                                                                                                                                                           
</div>

          {/* Cards Section
          <div className="cards-container">
            {cards.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1, delay: index * 0.2 }}
                className="card-wrapper"
              >
                <Card className="card">
                  <CardContent className="card-content">
                    <h2 className="card-title">{card.title}</h2>
                    <p className="card-subtitle">{card.subtitle}</p>
                    {card.icon}
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div> */}



<div className="monarch-hotel-container">
      <h1 className="monarch-hotel-heading">
       Official Venue of International Optometric Conference:   Monarch Imperial Hotel
      </h1>

      <p className="monarch-hotel-para">
        Monarch Imperial is a luxury dining and convention center located in the capital city of Sri Lanka offering true Sri Lankan hospitality coupled with international standards in cuisine and service.
        This well-appointed property includes 7 specialty restaurants inclusive of a western pub, the finest patisserie and Sri Lanka's largest elegant pillarless ballroom. The Imperial has stunning views of a private lake and 20 luxury guest rooms with ample parking. Thirty four (34) private dining rooms are conveniently located around the 7 specialty restaurants to offer greater privacy to celebrate special moments and to entertain corporate clients.
        The large lawn bordering the private lake is an ideal setting for outdoor events and alfresco dining.
      </p>

      <div 
        className="monarch-carousel-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="monarch-carousel">
          {visibleImages.map((image, i) => (
            <div 
              key={`${image.src}-${i}`}
              className={`carousel-item ${i === 1 ? 'center-item' : ''}`}
              onClick={() => handleImageClick(image)}
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
        <div className="carousel-controls">
          <button className="carousel-prev" onClick={movePrev}>&lt;</button>
          <button className="carousel-next" onClick={moveNext}>&gt;</button>
        </div>
      </div>

      {expandedImage && (
        <div className="image-modal" onClick={closeExpandedImage}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={closeExpandedImage}>&times;</button>
            <img 
              src={expandedImage.src} 
              alt={expandedImage.alt} 
              className="expanded-image"
            />
            <div className="image-caption">{expandedImage.alt}</div>
          </div>
        </div>
      )}
    </div>













<div className="explorer-srilanka-container"> 
  <h1 className="heading-explore-srilanka">
    E X P L O R E &nbsp; S R I L A N K A
  </h1>

  <div className="explore-srilanka-image">
    <img src="explore srilanka.png" alt="Explore Sri Lanka" />
    
    <Link to="/explore-srilanka">
    <button className='explore-button-more'>More Info</button>
    </Link>

  </div>
</div>

















          <div class="news-page">
          <div class="news-header">
            <h1>News</h1>
            <p>Stay up to date with our most recent news articles, stories, and updates.</p>
          </div>

        <div class="news-content">
          <div class="news-item">
            <div class="news-item-left">
              <img src="/logo.jpg" alt="Organizationn Logo" class="news-logo"  />
            </div>
            <div class="news-item-right">
            <h2>EXCITING ANNOUNCEMENT: Diyatharippu 1st International Optometric Conference 2026 Set to Redefine Eye Care</h2>
            <p>The Diyatharippu 1st International Optometric Conference is set to bring together global experts in optometry, vision science, and eye health to discuss the latest advancements in the field. This premier event will feature keynote speeches, panel discussions, and hands-on workshops covering topics such as myopia management, optometry, and emerging trends in Eye care.</p>
            
              <div class="upcoming-events-section">
                <Link to="/upcomingevent"><button class="upcoming-events-btn">Upcoming Events</button></Link>
              </div>

            </div>
          </div>

          <div class="virtual-learning-section">
            <div class="virtual-learning-image">
              <img src="newspage.jpg" alt="Virtual Learning Event" />
            </div>
            <div class="virtual-learning-text">
              <h2>HAND MADE EYE GLASSES</h2>
              <p>The tradition of crafting custom eyeglasses by hand in Sri Lanka, originating from the Gampola era, spans almost 700 years. This man is likely the final artisan proficient in shaping lenses from quartz. The photograph captures him shaping a type of quartz, locally called 'diyatharippu,' into the desired curvature using a specifically curved grinding stone. This picture was taken late at night, around 11 pm, utilizing a single studio light with a modifier and supplemental reflectors to illuminate the scene. He graciously performed his craft and accommodated our presence during the late hours</p>
            </div>
          </div>

        </div>
      </div>

            <div className="participate-container">
              <h1 className="participate-heading">
                Diyatharippu: Sri Lanka’s Pioneering International Optometric Conference
              </h1>
                <p className="participate-description">
                  Join leading optometrists, researchers, and vision science experts from across the globe.  
                  This conference is a hub of innovation, education, and collaboration, shaping the future of global eye care.</p>
                  <Link to="/payment">
                    <button className="participate-button"> Participate Now </button>
                  </Link>
              </div>


  





 

    </>
  );
}

export default Body;
